import { IServicesData } from '../request/handleResponse'
import { IService } from '../index'

export default function(item: IServicesData): IService {
  return {
    default: Number(item.default),
    hidden: Number(item.hidden),
    id: Number(item.id),
    price: Number(item.price),
    secondTax: Number(item.second_tax),
    serviceName: String(item.service_name),
    tax: Number(item.first_tax),
    userId: Number(item.id_user),
  }
}
